import React, { useEffect, useState } from "react";

import LayoutWrapper from "../../../common/LayoutWrapper";
import CloseSteps from "../../../common/Swipers/OrganDonationSteps";
import DocSwiper from "../../../common/Swipers/DocsSwiper";

import GetStarted from "../../../components/documents/organDonation/GetStarted";
import Declaration from "../../../components/documents/organDonation/Declaration";

import { useSelector, useDispatch } from "react-redux";
import { customTab, nextTab, preTab } from "../../../redux/slices/TabSlices";
import { getAssetsOnBoardingList } from "../../../redux/slices/features/assetsOnBoardingSlice";
import { connect } from "react-redux";
import { resetCard } from "../../../redux/slices/CardSlices";
import { visited } from "../../../redux/slices/features/assetsOnBoardingSlice";
import { getSBText } from "../../../utils/suggestionBoxUtilities";
import { organDonation } from "../../../constants/constants";

import "../../../components/yourAssets/BOA/BOA.scss";
import OrganDonationOverview from "../../../components/documents/organDonation/OrganDonationOverview";
import {
  getOrganDonationData,
  postOrganDonationData,
} from "../../../services/documentServices";
import {
  getDateFromDateStamp,
  getTimeFromDateStamp,
  getUserIdFromLocalStorage,
  overAllStatus,
  changeUpdateFormat,
} from "../../../utils/Utilities";
import {
  LinkButton,
  PrimaryButton,
  SecondaryButton,
} from "../../../common/Buttons";
import { useTranslation } from "react-i18next";
import { updateStatusQuoAuditTrails } from "../../../services/auditTrails";
import ModifiedByToaster from "../../../common/ModifiedByToaster";

const OrganDonationPage = ({
  currentTab,
  nextTab,
  preTab,
  customTab,
  resetCard,
  updates,
}) => {
  const { t, i18n } = useTranslation();
  let uID = getUserIdFromLocalStorage();
  let currentConsultantId = localStorage.getItem("currentConsultantId");
  const [steps, setSteps] = useState(organDonation);
  const [buttonDisabled, setButtonDisabled] = useState(false);
  const [data, setData] = useState(null);

  const handleResetCard = () => {
    resetCard();
  };
  const handleNext = () => {
    handleResetCard();
    nextTab();
  };
  const handleBack = () => {
    handleResetCard();
    preTab();
  };
  const handleCustomTab = (val) => {
    customTab(val);
  };
  const handleUpdatesTrails = async () => {
    const result = await updateStatusQuoAuditTrails(
      updates.map((item) => item.auditTrailId),
      currentConsultantId
    );
  };
  useEffect(() => {
    handleUpdatesTrails();
  }, []);
  const tabMaping = {
    1: (
      <GetStarted
        next={handleNext}
        pre={handleBack}
        setButtonDisabled={setButtonDisabled}
      />
    ),
    2: (
      <Declaration
        next={handleNext}
        pre={handleBack}
        setButtonDisabled={setButtonDisabled}
      />
    ),
    3: (
      <OrganDonationOverview
        next={handleNext}
        pre={handleBack}
        setButtonDisabled={setButtonDisabled}
      />
    ),
  };
  const dispatch = useDispatch();
  const tabStatuses = useSelector(
    (state) => state.assetsOnBoarding.assetsSuggestionBoxText
  );

  async function fetchData() {
    const result = await getOrganDonationData(uID);

    if (!result?.success || !result?.payLoad) {
      return;
    }

    const {
      organDonationAuthorizePerson,
      organDonationPersonDetail,
      declarationType,
    } = result.payLoad;

    if (result.payLoad && Object.keys(tabMaping).length === currentTab) {
      setData(result.payLoad);
    }

    const array = [
      organDonationPersonDetail?.stepStatus,
      declarationType < 5 ? 2 : organDonationAuthorizePerson?.stepStatus,
      2,
    ];

    const arr = generateStepsArray(array);
    setSteps(arr);
  }

  function generateStepsArray(array) {
    const arr = [];

    steps.forEach((elem, index) => {
      if (index !== steps.length - 1) {
        arr.push({ ...elem, stepStatus: array[index] });
      } else {
        const res = overAllStatus(array);
        arr.push({ ...elem, stepStatus: res ? 2 : 1 });
      }
    });

    return arr;
  }

  useEffect(() => {
    setData(null);
    fetchData();
  }, [currentTab]);

  useEffect(() => {
    dispatch(getAssetsOnBoardingList());
  }, []);

  const renderTab = () => {
    return (
      <>
        {tabMaping[currentTab]}
        {updates.length > 0 && (
          <ModifiedByToaster
            title={`${t("modified-by")} ${updates[0]?.username}` || ""}
            subTitle={` ${changeUpdateFormat(
              updates[0]?.updatedTime,
              i18n.language
            )}`}
          />
        )}
      </>
    );
  };
  return (
    <>
      <LayoutWrapper
        minHeight="calc(100vh - 100px) !important"
        borderShadow={true}
      >
        <DocSwiper
          tab={currentTab}
          back={handleBack}
          custom={handleCustomTab}
          list={steps}
          maxWidthSwiper={true}
          showTooltip={false}
          data={data}
          handleSubmitStatus={
            Object.keys(tabMaping).length === currentTab
              ? postOrganDonationData
              : null
          }
        />
        {renderTab()}
        {currentTab < 3 ? (
          <div
            style={{
              minWidth: "310px",
              display: "flex",
              justifyContent: "center",
            }}
          >
            <SecondaryButton
              title={t("save-and-continue")}
              bgColor="#E8D7E5"
              borderRadius="14px"
              width="180px"
              marginLeft="20px"
              border="none"
              hoverBgColor="color.magentaLight1"
              textTransform="initial"
              padding="0rem"
              height="2.7rem"
              form="form_submit"
              type="submit"
              disabled={buttonDisabled}
            />

            <LinkButton
              title={t("skip-for-now")}
              bgColor="color.transparent"
              borderRadius="14px"
              fontSize="0.8rem"
              width="150px"
              marginLeft="10px"
              padding="0"
              border="none"
              click={handleNext}
              textTransform="initial"
            />
          </div>
        ) : (
          <div
            className="button-container-2"
            style={{
              display: "flex",
              justifyContent: "center",
            }}
          >
            <PrimaryButton
              title={t("save")}
              bgColor="#E8D7E5"
              color="#444561"
              padding="10px 60px"
              textTransform="initial"
              borderRadius={"18px"}
              boxShadow={0}
              form="form_submit"
              type="submit"
            />
          </div>
        )}
      </LayoutWrapper>
    </>
  );
};

function mapStateToProps(state) {
  return {
    currentTab: state.currentTab.currentTab,
    updates: state.statusQuoDocuments.updates.organDonation,
  };
}
function mapDispatchToProps(dispatch) {
  return {
    nextTab: () => dispatch(nextTab()),
    preTab: () => dispatch(preTab()),
    customTab: (num) => dispatch(customTab(num)),
    resetCard: () => dispatch(resetCard()),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(OrganDonationPage);
